import React from 'react';
import PropTypes from "prop-types";
import compose from "recompose/compose";
import { connect } from "react-redux";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Style from 'assets/jss/material-dashboard-pro-react/views/cartStyle';
import { Card, MenuItem, Select, Typography } from '@material-ui/core'

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

// icons
import { CheckCircleOutline, Close, Info } from "@material-ui/icons";
import { BsCheckCircleFill } from 'react-icons/bs';
;

export function UpdateModal(props) {
    const {
        classes,
        history,
        setUpdateModal,
        Trash,
        orderStatus,
        updateArr,
        dropdownValue,
        setDropdownValue,
        setConfirmModal,
        setVoidModal,
    } = props

    return (
        <Card className={classes.confirmModalCard}>
            <GridContainer >
                <GridItem xs={12} style={{ justifyContent: "center", display: "flex" }}>
                    <h5 className={classes.cardHeader}>
                        Update the Status of Order
                    </h5>
                </GridItem>

                <GridItem xs={6} style={{ justifyContent: "center", display: "flex" }}>
                    <h5 className={classes.cardDescription} style={{ textAlign: "center" }}>
                        Current Status:
                    </h5>
                </GridItem>

                <GridItem xs={6} style={{ justifyContent: "center", display: "flex" }}>
                    <h5 className={classes.cardDescription} style={{ textAlign: "center" }}>
                        {orderStatus}
                    </h5>
                </GridItem>

                <GridItem xs={6} style={{ justifyContent: "center", display: "flex" }}>
                    <h5 className={classes.cardDescription} style={{ textAlign: "center" }}>
                        Update to:
                    </h5>
                </GridItem>

                <GridItem xs={6} style={{ justifyContent: "center", display: "flex" }}>
                    <Select
                        style={{width:"80%"}}
                        className={classes.selectMenuSort}
                        value={dropdownValue}
                        disableUnderline
                        classes={{
                            root: classes.selectText,
                        }}
                        onChange={(e) => {
                            setDropdownValue(e.target.value)
                        }}
                    >
                        {updateArr.map((o, i) => {
                            return (
                                <MenuItem
                                    key={i}
                                    value={o}
                                    classes={{
                                        root: classes.selectMenuItem,
                                    }}
                                >
                                    {o}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </GridItem>

                <GridItem
                    xs={12}
                    style={{ justifyContent: "center", display: "flex" }}
                >
                    <GridContainer>
                        <GridItem xs={6}>
                            <Button
                                className={classes.checkoutButton}
                                style={{ background: "#56CA93" }}
                                onClick={() => {
                                    setUpdateModal(false)
                                    setDropdownValue(orderStatus)
                                }}
                            >
                                <Trash style={{ marginRight: "10px" }} /> Cancel
                            </Button>
                        </GridItem>

                        <GridItem xs={6}>
                            <Button
                                className={classes.checkoutButton}
                                onClick={() => {
                                    setUpdateModal(false)
                                    if(dropdownValue === "Canceled"){
                                        setVoidModal(true)
                                    }else{
                                        setConfirmModal(true)
                                    }
                                }}
                            >
                                <BsCheckCircleFill style={{ marginRight: "10px" }} /> Confirm
                            </Button>
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </Card>
    )
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(actions) {
    return (dispatch) => ({
    });
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(UpdateModal);